import React, {useState} from 'react';
import {Redirect} from 'react-router-dom';

const UserForm = ({api, user, submitFunction, cancelFunction, requirePassword = true}) => {

    const [username, setUsername] = useState(user.display_name || "");
    const [groupId, setGroupId] = useState(user.group_id || -1);
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [formError, setFormError] = useState("");
    const [formDone, setFormDone] = useState(false);

    const performValidation = () => {
        if(username.length < 3) {
            setFormError("Username must be at least 3 characters");
            return false;
        }
        if(groupId == -1) {
            setFormError("User must have a group");
            return false;
        }

        // Skip password validation if empty and not required
        if(requirePassword == false && password == '' && passwordConfirmation == '') return true;

        if(password.length < 8) {
            setFormError("Password must be at least 8 characters");
            return false;
        }
        if(password != passwordConfirmation) {
            setFormError("Passwords do not match");
            return false;
        }
        return true;
    }

    const submitted = async(evt) => {
        evt.preventDefault();
        setFormError('');
        if(!performValidation()) return;
        let result = await submitFunction(user.id || null, username, groupId, password, passwordConfirmation).catch(err => {
            if(err.response) {
                setFormError(err.response.data.error || err.message);
            } else {
                setFormError(err.message);
            }
        });
        if(!!result) {
            setFormDone(true);
        }
    }

    const cancelled = async(evt) => {
        evt.preventDefault();
        cancelFunction();
    }

    const usernameChange = (evt) => {
        setUsername(evt.target.value);
    }
    const groupIdChange = (evt) => {
        setGroupId(evt.target.value);
    }
    const passwordChange = (evt) => {
        setPassword(evt.target.value);
    }
    const passwordConfirmationChange = (evt) => {
        setPasswordConfirmation(evt.target.value);
    }

    if(formDone) {
        return <Redirect to="/users"></Redirect>
    }

    if(user && user.federated) {
        return <form className="LoginForm" onSubmit={submitted}>
            <div className="form-group">
                <label htmlFor="groupId">Group</label>
                <select className="form-control" id="groupId" value={groupId} onChange={groupIdChange}>
                    <option disabled value="-1">No Group</option>
                    {api.data.groups != null ? api.data.groups.map(g => <option value={g.id}>{g.name}</option>) : <option value="-1">Error: No groups found</option>}
                </select>
            </div>
            <span className="text-danger">{formError}</span>
            <button type="button" className="btn btn-danger" onClick={cancelled}>Cancel</button>
            <button type="submit" className="btn btn-primary float-right">Submit</button>
        </form>
    }

    return <form className="LoginForm" onSubmit={submitted}>
        <div className="form-group">
            <label htmlFor="name">Username</label>
            <input type="text" className="form-control" required id="username" value={username} onChange={usernameChange} />
        </div>
        <div className="form-group">
            <label htmlFor="groupId">Group</label>
            <select className="form-control" id="groupId" value={groupId} onChange={groupIdChange}>
                <option disabled value="-1">No Group</option>
                {api.data.groups != null ? api.data.groups.map(g => <option value={g.id}>{g.name}</option>) : <option value="-1">Error: No groups found</option>}
            </select>
        </div>
        <div className="form-group">
            <label htmlFor="name">Password</label>
            <input type="password" className="form-control" required={requirePassword} id="password" value={password} onChange={passwordChange} />
        </div>
        <div className="form-group">
            <label htmlFor="name">Confirm Password</label>
            <input type="password" className="form-control" required={requirePassword} id="passwordConfirmation" value={passwordConfirmation} onChange={passwordConfirmationChange} />
            <small class="form-text text-muted">
                Passwords must be at least 8 characters long and contain both upper and lowercase letters, a number and a symbol.
            </small>
        </div>
        <span className="text-danger">{formError}</span>
        <button type="button" className="btn btn-danger" onClick={cancelled}>Cancel</button>
        <button type="submit" className="btn btn-primary float-right">Submit</button>
    </form>
}

export default UserForm;